import React, { Component } from 'react';
import { Button, Alert, Row } from 'react-bootstrap';

class ChangePlanAlertIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAlertChangePlan: false,
    }
  }

  redirectPlan() {
    this.props.data.data.history.push('plans');
  }

  activarAlerta(_value) {
    const self = this;
    if (_value === "Free") {
      setTimeout(function () {
        self.setState({
          showAlertChangePlan: true
        });
      }, 10000);
    }
  }

  render() {
    return (
      <div>
        {/* {
          (this.props.userPlan) &&
          this.activarAlerta(this.props.userPlan)
        } */}
        <Alert
          className='alert_change_plan'
          onClose={() => { this.setState({ showAlertChangePlan: false }) }}
          dismissible
          show={this.state.showAlertChangePlan}
          variant="success">
          <Row style={{ justifyContent: 'center' }}>
            <p style={{ color: "#292D3D", fontSize: 20, marginBottom: 0 }}>
              You currently have the <strong>{this.props.userPlan} Plan</strong>. Change now and get more wallets and addresses.
              </p>
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            <p style={{ color: "#FFFFFF", marginBottom: 0 }}>
              <Button className="alert_change_plan_button" onClick={() => { this.redirectPlan() }}>Change plan</Button>
            </p>
          </Row>
        </Alert>
      </div>
    );
  }
} export default ChangePlanAlertIndex;